/**
 * Frontend mirror of the backend partner fence (backend/src/modules/grievances/
 * partner-scope.ts, fix round 1 / C1). A partner login (lsp_manager / lsp_agent /
 * lsp_developer) may call only its own role's API paths; the shell skips every other call for them so a
 * partner page load never fires requests the server answers with 403 PARTNER_FENCE.
 * Paths are relative to the axios baseURL `/api/v1` (absolute `/api/v1/...` also accepted).
 */
export const PARTNER_AUTH_PATHS: ReadonlySet<string> = new Set([
  '/auth/me',
  '/auth/login',
  '/auth/logout',
  '/auth/change-password',
  '/auth/profile',
  '/auth/me-update',
  '/auth/forgot-password',
  '/auth/reset-password',
]);

const GRIEVANCE_PREFIXES = ['/partner/grievances', '/notifications'];

/** Per-role allow-lists (mirror of backend ALLOWED_PREFIXES_BY_ROLE, 2026-10-08 lsp_developer). */
const PREFIXES_BY_ROLE: Record<string, string[]> = {
  lsp_manager: GRIEVANCE_PREFIXES,
  lsp_agent: GRIEVANCE_PREFIXES,
  lsp_developer: ['/partner/dev-access', '/notifications'],
};

export function isPartnerRoleName(name: string | null | undefined): boolean {
  return Object.prototype.hasOwnProperty.call(PREFIXES_BY_ROLE, (name ?? '').toLowerCase());
}

/**
 * true = this fenced login may call `url`. `roleName` picks the role's own list;
 * omitted (existing callers) = the grievance partner list.
 */
export function isPartnerApiPath(url: string, roleName?: string | null): boolean {
  let p = url.split('?')[0];
  if (p.startsWith('/api/v1/')) p = p.slice('/api/v1'.length);
  if (!p.startsWith('/')) p = `/${p}`;
  if (PARTNER_AUTH_PATHS.has(p)) return true;
  const prefixes = PREFIXES_BY_ROLE[(roleName ?? '').toLowerCase()] ?? GRIEVANCE_PREFIXES;
  return prefixes.some((x) => p === x || p.startsWith(`${x}/`));
}
